import { render, staticRenderFns } from "./WalletCallBackDesktop.vue?vue&type=template&id=53639bf4&scoped=true"
import script from "./WalletCallBackDesktop.vue?vue&type=script&lang=js"
export * from "./WalletCallBackDesktop.vue?vue&type=script&lang=js"
import style0 from "./WalletCallBackDesktop.vue?vue&type=style&index=0&id=53639bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53639bf4",
  null
  
)

export default component.exports